import styled from 'styled-components'

import { Radio } from 'formik-antd'

const { Button } = Radio

const RadioButton = styled(Button)``

export default RadioButton
